module.exports = __webpack_public_path__ + "img/fourday_ps_25.bacb9c22.jpg";